import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { ProgressCardItem as ProgressCardItemType } from './types';
import { ProgressDetailsMarkupMAIQ } from '../../ProgressDetailsMarkupMAIQ';

const ItemContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '&:last-child': {
    marginBottom: 0,
  },
}));

const HeaderText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
  fontWeight: 400,
}));

interface DefaultProgressCardItemProps {
  item: ProgressCardItemType;
}

export const DefaultProgressCardItem: React.FC<DefaultProgressCardItemProps> = ({ item }) => {
  const { header, details } = item;
  
  // Determine if this is a number value (for audience count)
  const isNumberValue = header?.toLowerCase().includes('count') || 
                       header?.toLowerCase().includes('number') ||
                       /^\d+$/.test(details || '');
  
  // Determine if this is a list (for filters)
  const isListValue = Array.isArray(details) || 
                     (typeof details === 'string' && details.includes('\n')) ||
                     header?.toLowerCase().includes('filter');

  const renderValue = () => {
    if (isNumberValue) {
      return (
        <ProgressDetailsMarkupMAIQ 
          content={details || '0'} 
          variant="large" 
        />
      );
    }
    
    if (isListValue && typeof details === 'string') {
      return (
        <ProgressDetailsMarkupMAIQ 
          content={details} 
          variant="default" 
        />
      );
    }
    
    return (
      <ProgressDetailsMarkupMAIQ 
        content={details || ''} 
        variant="default" 
      />
    );
  };

  if (!header && !details) {
    return null;
  }

  return (
    <ItemContainer>
      {header && (
        <HeaderText>
          {header}
        </HeaderText>
      )}
      {renderValue()}
    </ItemContainer>
  );
};